import {h, Component} from 'preact';
import {PropTypes} from 'preact-compat';
import AutoCompleteInput from './AutoCompleteInput';

export default class TagsInput extends Component {
    static get propTypes() {
        return {
            placeholder: PropTypes.string,
            options: PropTypes.array,
            defaultValue: PropTypes.string,
            onChange: PropTypes.func
        };
    }

    state = {
        valuesSelected: []
    };
    select;

    componentDidMount() {
        const { defaultValue } = this.props;

        if (defaultValue && !this.state.valuesSelected.length) {
            this.setState({valuesSelected: typeof defaultValue === 'string' ? [defaultValue] : defaultValue});
        }
    }

    handleSelectChange = value => {
        if (this.state.valuesSelected.filter(v => v.toLowerCase() == value.toLowerCase()).length > 0) {
            return;
        }

        this.setState(currentState => ({
            valuesSelected: [...currentState.valuesSelected, value]
        }));

        $(this.select).val([...this.state.valuesSelected, value]);

        if (this.props.onChange) {
            this.props.onChange(this.state.valuesSelected);
        }
    };

    initAutoComplete = (searchPhrase, callback) => {
        const searchPhraseLowercase = searchPhrase.toLowerCase();
        const results = this.props.options
            .map(({value}) => value)
            .filter(pref => {
                return pref.toLowerCase().includes(searchPhraseLowercase);
            });
        callback(results);
    };

    handleRemoveTag = tag => {
        this.setState(currentState => ({
            valuesSelected: currentState.valuesSelected.filter(
                val => val !== tag
            )
        }));

        if (this.props.onChange) {
            this.props.onChange(this.state.valuesSelected);
        }
    };

    render() {
        const {options, limit, name, placeholder, ...rest} = this.props;
        const limitTags = limit
            ? this.state.valuesSelected.length >= limit
            : false;
        const normalizedOptions =
            typeof options === 'string' ? [options] : options;

        return (
            <div className='tags-input-container form-control'>
                <select
                    ref={el => (this.select = el)}
                    style='display: none;'
                    name={name}
                    multiple>
                    {(normalizedOptions || []).map(({value}) => (
                        <option value={value} style='display:none;' />
                    ))}
                </select>
                <div className='tags-container'>
                    {this.state.valuesSelected.map(tag => (
                        <span className='tags-input-tag'>
                            <i
                                className='icon-nav-close'
                                onClick={() => this.handleRemoveTag(tag)}
                            />
                            {tag}
                        </span>
                    ))}
                </div>
                {!limitTags && (
                    <AutoCompleteInput
                        onTextChange={this.initAutoComplete}
                        initialEntries={(normalizedOptions || []).map(
                            ({value}) => value
                        )}
                        inputProps={{
                            className: 'tags-input',
                            placeholder: !this.state.valuesSelected.length && !!placeholder ? placeholder : ''
                            // name: inputName,
                            // ...rest
                        }}
                        asSelect
                        onSelect={this.handleSelectChange}
                    />
                )}
            </div>
        );
    }
}
